import axios from "axios";

const http = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});
const data = (r) => r.data;

let onUnauthorized = () => {};
let refreshing = null;
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

http.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !cfg.url.startsWith("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || http.post("/auth/refresh").finally(() => {
        refreshing = null;
      });
      try {
        await refreshing;
        return http(cfg);
      } catch (e) {
        onUnauthorized();
      }
    }
    return Promise.reject(error);
  }
);

export const apiError = (e, fallback = "Operazione non riuscita") => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
};

export const api = {
  login: (body) => http.post("/auth/login", body).then(data),
  googleLogin: (session_id) => http.post("/auth/google", { session_id }).then(data),
  forgotPassword: (email) => http.post("/auth/forgot-password", { email }).then(data),
  resetPassword: (token, password) => http.post("/auth/reset-password", { token, password }).then(data),
  logout: () => http.post("/auth/logout").then(data),
  me: () => http.get("/auth/me").then(data),
  refresh: () => http.post("/auth/refresh").then(data),
  changePassword: (body) => http.post("/auth/change-password", body).then(data),
  getUsers: () => http.get("/users").then(data),
  createUser: (body) => http.post("/users", body).then(data),
  resetUserPassword: (id, password) => http.post(`/users/${id}/password`, { password }).then(data),
  deleteUser: (id) => http.delete(`/users/${id}`).then(data),
  getEmployees: () => http.get("/employees").then(data),
  createEmployee: (body) => http.post("/employees", body).then(data),
  updateEmployee: (id, body) => http.put(`/employees/${id}`, body).then(data),
  reorderEmployees: (body) => http.post("/employees/reorder", body).then(data),
  deleteEmployee: (id) => http.delete(`/employees/${id}`).then(data),
  getVehicles: () => http.get("/vehicles").then(data),
  createVehicle: (body) => http.post("/vehicles", body).then(data),
  updateVehicle: (id, body) => http.put(`/vehicles/${id}`, body).then(data),
  deleteVehicle: (id) => http.delete(`/vehicles/${id}`).then(data),
  getAbsences: (params) => http.get("/absences", { params }).then(data),
  createAbsence: (body) => http.post("/absences", body).then(data),
  createAbsenceRange: (body) => http.post("/absences/range", body).then(data),
  deleteAbsence: (id) => http.delete(`/absences/${id}`).then(data),
  copyTask: (id, body) => http.post(`/tasks/${id}/copy`, body).then(data),
  assignTask: (id, body) => http.post(`/tasks/${id}/assign`, body).then(data),
  reorderTasks: (body) => http.post("/tasks/reorder", body).then(data),
  assignRecurringWeek: (body) => http.post("/tasks/recurring/assign-week", body).then(data),
  syncRecurring: (body) => http.post("/tasks/recurring/sync", body).then(data),
  getTasks: (params) => http.get("/tasks", { params }).then(data),
  createTask: (body) => http.post("/tasks", body).then(data),
  updateTask: (id, body) => http.patch(`/tasks/${id}`, body).then(data),
  deleteTask: (id) => http.delete(`/tasks/${id}`).then(data),
};
